export const webDevelopmentQuestions = [
  {
    id: 'webdev-001',
    category: 'Web Development',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which language gives web pages their structure?',
    options: ['HTML', 'CSS', 'SQL', 'Python'],
    answer: 'HTML',
    insight: 'HTML defines the content and structure of a web page.',
    tags: ['html', 'frontend', 'web'],
    points: 10,
  },
  {
    id: 'webdev-002',
    category: 'Web Development',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which language is mainly used to style web pages?',
    options: ['CSS', 'HTML', 'SQL', 'JSON'],
    answer: 'CSS',
    insight: 'CSS controls layout, colors, typography, and visual styling.',
    tags: ['css', 'styling', 'frontend'],
    points: 10,
  },
  {
    id: 'webdev-003',
    category: 'Web Development',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'JavaScript can be used to add interactivity to web pages.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'JavaScript powers interactive behavior in browsers.',
    tags: ['javascript', 'interactivity', 'frontend'],
    points: 10,
  },
  {
    id: 'webdev-004',
    category: 'Web Development',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'In React, which hook is commonly used to manage component state?',
    options: ['useState', 'useRoute', 'useStyle', 'useServer'],
    answer: 'useState',
    insight: 'useState stores values that can change between renders.',
    tags: ['react', 'hooks', 'state'],
    points: 20,
  },
  {
    id: 'webdev-005',
    category: 'Web Development',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'What does API stand for?',
    options: ['Application Programming Interface', 'Automated Page Index', 'Applied Program Instance', 'Application Pixel Input'],
    answer: 'Application Programming Interface',
    insight: 'An API defines how software parts communicate.',
    tags: ['api', 'software', 'web'],
    points: 20,
  },
  {
    id: 'webdev-006',
    category: 'Web Development',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'Responsive design helps layouts work across different screen sizes.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Responsive design adapts interfaces for phones, tablets, and desktops.',
    tags: ['responsive design', 'css', 'layout'],
    points: 20,
  },
  {
    id: 'webdev-007',
    category: 'Web Development',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which HTTP method is commonly used to request data?',
    options: ['GET', 'PATCH', 'DELETE', 'TRACE'],
    answer: 'GET',
    insight: 'GET requests retrieve resources from a server.',
    tags: ['http', 'api', 'requests'],
    points: 20,
  },
  {
    id: 'webdev-008',
    category: 'Web Development',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'What does the DOM represent?',
    options: ['Document Object Model', 'Data Output Map', 'Digital Object Machine', 'Display Order Module'],
    answer: 'Document Object Model',
    insight: 'The DOM is a tree-like representation of a web document.',
    tags: ['dom', 'browser', 'javascript'],
    points: 30,
  },
  {
    id: 'webdev-009',
    category: 'Web Development',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which tool is commonly used to bundle modern JavaScript apps?',
    options: ['Vite', 'SQLite', 'Figma', 'Postman'],
    answer: 'Vite',
    insight: 'Vite is a modern frontend build tool and dev server.',
    tags: ['vite', 'build tools', 'javascript'],
    points: 30,
  },
  {
    id: 'webdev-010',
    category: 'Web Development',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'localStorage stores string data in the browser.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'localStorage persists string key-value pairs in the browser.',
    tags: ['localstorage', 'browser', 'storage'],
    points: 30,
  },
];
